import { render } from "./xiaohsaccount.vue?vue&type=template&id=26874a30&scoped=true"
import script from "./xiaohsaccount.vue?vue&type=script&lang=js"
export * from "./xiaohsaccount.vue?vue&type=script&lang=js"

import "./xiaohsaccount.vue?vue&type=style&index=0&id=26874a30&lang=scss&scoped=true"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26874a30"]])

export default __exports__